import { render, staticRenderFns } from "./zixunzhongxin.vue?vue&type=template&id=51787b48&scoped=true"
import script from "./zixunzhongxin.vue?vue&type=script&lang=js"
export * from "./zixunzhongxin.vue?vue&type=script&lang=js"
import style0 from "./zixunzhongxin.vue?vue&type=style&index=0&id=51787b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51787b48",
  null
  
)

export default component.exports